import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '__components/Inputs/Select';
import Cols from '__components/Layout/Cols';
import { MergeFieldValidationKey, MergeFieldValidationOption } from './types';
import { getMergeFieldValidationOptions } from './helpers';

type LLMMergeFieldValidationProps = {
  value: MergeFieldValidationKey;
  onChange: (option: MergeFieldValidationOption) => void;
  disabled: boolean;
};

export const LLMMergeFieldValidation: FC<LLMMergeFieldValidationProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const options = useMemo(() => getMergeFieldValidationOptions(t), [t]);

  return (
    <Cols columns={3} gutter="20px">
      <Select
        label={t('Merge Field Validation')}
        placeholder={t('Choose Merge Field Validation')}
        value={value}
        options={options}
        onChange={onChange}
        menuInline
        margin
        disabled={disabled}
        captureMenuScroll={false}
      />
    </Cols>
  );
};
